import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
//查询服务热线
export const findReminder =(params)=>{
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/reminder_call?` + params,
        method: 'GET'
    })
}
//新增服务热线
export const addReminder = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/reminder_call`,
        method: 'POST',
        data: data
    })
}
//修改服务热线
export const updateReminder = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/reminder_call`,
        method: 'PUT',
        data: data
    })
}
//删除服务热线
export const delReminder = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/reminder_call/${ids}`,
        method: 'DELETE'
    })
}
